/**
 * Tier 3 EGM — bootstrap 진입 전 앱 echarts/core 에 CanvasRenderer 등록.
 * npm @axsolutionsdev/mes-fe 구버전 bootstrap 에 등록이 없을 때 대시보드 `Renderer 'undefined'` 방지.
 * mes-fe ^0.1.4+ `@axsolutionsdev/mes-fe/echarts-register` 로 대체 가능.
 */
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LegacyGridContainLabel } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

let registered = false;

export function registerMesEcharts(): void {
  if (registered) return;
  registered = true;
  echarts.use([
    CanvasRenderer,
    BarChart,
    LineChart,
    PieChart,
    GridComponent,
    GraphicComponent,
    LegendComponent,
    TooltipComponent,
    LegacyGridContainLabel,
  ]);
}

registerMesEcharts();
